/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Final_DescriptionInputs */

const en_why_listening_final_description = /** @type {(inputs: Why_Listening_Final_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles, PDFs, emails and newsletters, read aloud in a natural voice on every device you own.`)
};

const es_why_listening_final_description = /** @type {(inputs: Why_Listening_Final_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos, PDF, correos y newsletters, leídos en voz alta con una voz natural en todos tus dispositivos.`)
};

/**
* | output |
* | --- |
* | "Articles, PDFs, emails and newsletters, read aloud in a natural voice on every device you own." |
*
* @param {Why_Listening_Final_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_final_description = /** @type {((inputs?: Why_Listening_Final_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Final_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_final_description(inputs)
	return en_why_listening_final_description(inputs)
});